<div id="admin-container">
    <ul class="nav flex-column">
        <li class="nav-item">
            <a href="#" data-toggle="tab" data-target="#sale-ia-general-tab"  aria-expanded="false" class="nav-link active">
                <span class="mdi mdi-home-variant d-md-none d-block"></span>
                <span class="d-none d-md-block">General</span>
            </a>
        </li>
        <li class="nav-item">
            <a href="#" data-toggle="tab" data-target="#sale-ia-commission-tab"  aria-expanded="true" class="nav-link">
                <span class="mdi mdi-account-circle d-md-none d-block"></span>
                <span class="d-none d-md-block">Commission</span>
            </a>
        </li>
        <!--
        <li class="nav-item">
            <a href="#profit" data-toggle="tab" aria-expanded="false" class="nav-link">
                <span class="mdi mdi-settings-outline d-md-none d-block"></span>
                <span class="d-none d-md-block">Profit</span>
            </a>
        </li>
        <li class="nav-item">
            <a href="#post-sale-credits" data-toggle="tab" aria-expanded="false" class="nav-link">
                <span class="mdi mdi-settings-outline d-md-none d-block"></span>
                <span class="d-none d-md-block">Post-Sale</span>
            </a>
        </li>
        -->
    </ul>

    <section class="tab-content">
        <div class="tab-pane fade active show" id="sale-ia-general-tab" aria-labelledby="general-tab">
            <div class="container-fluid">
                <form [formGroup]="form">
                    <div class="form-group row">
                        <label for="lotId" class="col-4 col-form-label">Lot</label>
                        <div class="col">
                            <select class="form-control form-control-sm" formControlName="lotId">
                                @for (lot of lotsAvailable; track lot.id) {
                                    <option value="{{lot.id}}">{{lot.name}}</option>
                                }
                            </select>
                        </div>
                    </div>
                    @if (bhph) {
                        <div class="form-group row">
                            <label for="collectionMethod" class="col-4 col-form-label">Collection Method</label>
                            <div class="col">
                                <select class="form-control form-control-sm" id="collectionMethod" formControlName="collectionMethod">
                                    @for (method of collectionMethods; track method) {
                                        <option [value]="method">{{method}}</option>
                                    }
                                </select>
                            </div>
                        </div>
                    }
                    <div class="form-group row">
                        <label for="collector" class="col-4 col-form-label">Collector</label>
                        <div class="col">
                            <select id="collector" class="form-control form-control-sm" formControlName="collector">
                                <option value="0">Unassigned</option>
                                @for (collector of collectors; track collector.id) {
                                    <option [value]="collector.id">{{collector.name}}</option>
                                }
                            </select>
                        </div>
                    </div>
                    <div class="form-group row">
                        <label for="businessSource" class="col-4 col-form-label">Business Source</label>
                        <div class="col">
                            <select class="form-control form-control-sm" id="businessSource" formControlName="businessSource">

                            </select>
                        </div>
                    </div>
                    <div class="form-group row">
                        <label for="lateFeePercent" class="col-4 col-form-label">Late Fee Percent</label>
                        <div class="col">
                            <percent-input [id]="'lateFeePercent'" [control]="form.get('lateFeePercent')"></percent-input>
                        </div>
                    </div>
                    <div class="form-group row">
                        <label for="referralFee" class="col-4 col-form-label">Referral Fee</label>
                        <div class="col">
                            <currency-input [id]="'referralFee'" [control]="form.get('referralFee')"></currency-input>
                        </div>
                        <div class="col">
                            <input type="text" id="referredBy" class="form-control form-control-sm" formControlName="referredBy" placeholder="To" />
                        </div>
                    </div>
                </form>
            </div>
        </div>

        <div class="tab-pane fade" id="sale-ia-commission-tab">
            <sale-commission [saleId]="sale ? sale.id : 0"></sale-commission>
        </div>

        <!--
        <div class="tab-pane fade" id="profit">
            <p class="mb-0">Profit</p>
        </div>
        <div class="tab-pane fade" id="post-sale-credits" aria-labelledby="post-sale-credits-tab">
            <p class="mb-0">Post-Sale Credits</p>
        </div>
        -->
    </section>
</div>
